import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Client } from '../../../shared/models/customer.model';
import { ConnectionCheck } from '../../../utils/connection-check';

@Component({
  selector: 'app-customers-list',
  templateUrl: './customers-list.component.html',
  standalone: false
})
export class CustomerListComponent implements OnInit {
  @Input() public customers: Client[];
  @Output() public toggleSelect: EventEmitter<any> = new EventEmitter();
  @Output() public toggleScroll: EventEmitter<any> = new EventEmitter();
  public orderByFieldName = 'name';
  public direction = 'desc';

  ngOnInit() {}

  public selectCustomer(customer: Client) {
    this.toggleSelect.emit(customer);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }

  get isConnection() {
    return ConnectionCheck.isConnection;
  }

  scroll(event: Event) {
    if (!this.isConnection) return;

    const target = event.target as HTMLDivElement;
    if (target.scrollHeight - target.clientHeight - target.scrollTop < 600) {
      this.toggleScroll.emit();
    }
  }
}
